import React, { useState, useEffect } from 'react';
import { MagnifyingGlass } from '@zocdoc-frontend-common/assets-icons';
import {
    withCustomMetrics,
    EVENT_INITIATORS,
    INTERACTION_TYPES,
} from '@zocdoc-frontend-common/utils-frontend-metrics';
import { CompactModal } from '@zocdoc-mezzanine/components-modal';
import { getSearchUrl } from '../../utils/getSearchUrl';

const InsurancePayForMyselfModal = ({
    procedureId,
    professionalName,
    professional,
    insuranceCarrierId,
    insurancePlanId,
    whiteLabelVanityUrl,
    sendMetric,
}) => {
    const providerName = professionalName || 'This doctor';

    const [showModal, setShowModal] = useState(false);

    const isPayForMyselfSelected = (insuranceCarrierId, insurancePlanId) => {
        const PAY_MYSELF_IDS = new Set([-2, '-2', 'ic_-2', 'ip_-2']);
        return (
            PAY_MYSELF_IDS.has(insuranceCarrierId) ||
            PAY_MYSELF_IDS.has(insurancePlanId)
        );
    };

    useEffect(() => {
        if (isPayForMyselfSelected(insuranceCarrierId, insurancePlanId)) {
            sendMetric({
                action: 'Pay For Myself Modal Viewed',
                element: 'InsurancePayForMyselfModal',
                initiator: EVENT_INITIATORS.USER,
                interactionType: INTERACTION_TYPES.VIEW,
            });
            setShowModal(true);
        }
    }, [insuranceCarrierId, insurancePlanId, sendMetric]);

    const searchUrl = getSearchUrl(
        procedureId,
        professional.specialtyId,
        insuranceCarrierId,
        insurancePlanId,
        whiteLabelVanityUrl
    );

    const handleClose = () => {
        sendMetric({
            action: 'Close modal',
            element: 'CloseButton',
            initiator: EVENT_INITIATORS.USER,
            interactionType: INTERACTION_TYPES.CLICK,
        });

        setShowModal(false);
    };

    const onClickSearch = () => {
        sendMetric({
            action: 'Click Find other providers',
            element: 'Find other providers',
            initiator: EVENT_INITIATORS.USER,
            interactionType: INTERACTION_TYPES.CLICK,
        });
    };

    const titleText = `${providerName} only accepts in-network patients`;

    const primaryButtonProps = {
        children: (
            <span>
                <MagnifyingGlass /> <span>Find other providers</span>
            </span>
        ),
        href: searchUrl,
        beforeClick: onClickSearch,
    };
    if (showModal) {
        return (
            <CompactModal
                data-test="insurance-pay-for-myself-modal"
                title={titleText}
                primaryButtonProps={primaryButtonProps}
                onClose={handleClose}
            >
                We have many other providers that do accept cash pay clients.
            </CompactModal>
        );
    } else {
        return null;
    }
};

export default withCustomMetrics({
    component: 'InsurancePayForMyselfModal',
    section: 'InsurancePayForMyselfModal',
})(InsurancePayForMyselfModal);
